module.exports = __webpack_public_path__ + "static/media/execute_readyforexam.75a3b1d7.png";